import gql from 'graphql-tag';
import FieldsEmployeeTransport from "graphql/fields/FieldsEmployeeTransport";

export default gql(`
	query employee_transports( $date: [String] ) {
		employee_transports( date: $date ) {
			${FieldsEmployeeTransport}
		}
	}
`);

